import { Contest } from "interfaces/leaderboard/contest.ts";
import ContestItem from "./contest-item.tsx";
import { useNavigate } from "react-router-dom";
import styles from "./contest-item-home.module.scss";
import { useAppSelector } from "state/hooks.ts";
import { getEntriesByContestId } from "state/slices/contests-slice.ts";
import { getGroupState } from "state/slices/group-slice.ts";
import { getContestEntryFee, getContestPagePath } from "utils/contest-group-utils.ts";

interface ContestItemProps {
  contest: Contest;
}

const ContestItemHome = ({ contest }: ContestItemProps) => {

  const navigate = useNavigate();

  const userContestEntries = useAppSelector((state) => getEntriesByContestId(state, contest.id)) || [];
  const groupId = useAppSelector(getGroupState).id;

  const handleClick = () => {
    navigate(getContestPagePath(contest.id, groupId), { state: { contest: contest } });
  };

  return (
    <>
      <div
        className={styles.wrapper}
        onClick={handleClick}
      >
        <ContestItem
          contest={contest}
          userContestEntries={userContestEntries}
          entryFeeOverride={getContestEntryFee(contest, groupId)}
        />
      </div>
    </>
  );
};

export default ContestItemHome;
